module.exports = __webpack_public_path__ + "images/retailer-margins-black-28c2e942.svg";